<template>
  <b-modal id="project-image-metadata-modal" size="lg" ref="projectImageMetadataModal" no-close-on-backdrop
    body-class="p-0" centered>
    <template slot="modal-header" class="mx-auto">
      <div>
        <h4 class="">Project Image Metadata Removal</h4>
        <p class="mb-0">
          Should observation image metadata be removed?
        </p>
      </div>

    </template>
    <template slot="default">
      <b-form-group class="p-4" stacked v-slot="{ ariaDescribedby }">
        <p>
          Sensitive image metadata include but are not limited to:<br>
          location coordinates (exact latitude and longitude),
          altitude,
          date and time stamps,
          device used,
          software used
        </p>
        <b-form-radio v-model="imageMetadataRemoval" :aria-describedby="ariaDescribedby" name="image-metadata-radios"
          :value="false" size="lg">
          <i class="fa-solid fa-file-shield fa-2xl"></i>
          <span class="h3">Keep Image Metadata</span>
          <b-form-group label-cols="12" label-size="md" label="">
            <span>
              Image(s) added to an observation will <b><u>NOT</u></b> have metadata removed.</span>
          </b-form-group>
        </b-form-radio>
        <br>
        <b-form-radio v-model="imageMetadataRemoval" :aria-describedby="ariaDescribedby" name="image-metadata-radios"
          :value="true" size="lg">
          <i class="fa-solid fa-file-half-dashed fa-2xl"></i>
          <span class="h3">Remove Image Metadata</span>
          <b-form-group label-cols="12" label-size="md" label="" label-for="input-sm">
            <span>
              Image(s) added to an observation will have metadata removed.
            </span>
          </b-form-group>
        </b-form-radio>
      </b-form-group>
    </template>
    <template #modal-footer>
      <span class="mr-5">Save the Project to apply this change</span>
      <b-button size="md" variant="primary" @click="onClose()">
        Done
      </b-button>
    </template>
  </b-modal>
</template>

<script>

import { mapGetters, mapActions } from "vuex";

export default {
  components: {},
  props: {
    imageMetadataRemovalValue: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      // default privacy value is public
      imageMetadataRemoval: false,
    }
  },
  mounted() {
  },
  created() {
    console.log('privacy prop', this.imageMetadataRemovalValue, JSON.stringify(this.imageMetadataRemoval))
    this.imageMetadataRemoval = this.imageMetadataRemovalValue
    console.log('privacy prop', this.imageMetadataRemovalValue, JSON.stringify(this.imageMetadataRemoval))
  },
  watch: {
    imageMetadataRemovalValue(newVal, oldVal) {
      if (newVal) {
        this.imageMetadataRemoval = newVal
      }
    }
  },
  computed: {
    ...mapGetters({}),
  },
  methods: {
    ...mapActions({}),

    onClose() {
      // emit data value to parent component
      this.$emit('imageMetadataChange', this.imageMetadataRemoval);
      // close modal
      this.$refs.projectImageMetadataModal.hide()
    }
  },
}

</script>

<style scoped lang="scss"></style>
